import React from 'react';

import Logo from '../Logo';
import { Container } from './styles';

const Footer: React.FC = () => (
  <Container>
    <Logo version="footer" />
  </Container>
);

export default Footer;
